export const getRadarChartOptions = (
  title: string,
  radarColor: string,
  categories: string[][],
  isLightMode: boolean
) => {
  const labelColors = []

  for (let i = 0; i < 50; i++) {
    labelColors.push(isLightMode ? '#1F2937' : '#dfdfdf')
  }

  return {
    chart: {
      zoom: {
        enabled: true
      },
      toolbar: {
        show: true
      },
      background: isLightMode ? '#fff' : '#383838'
    },
    title: {
      text: title,
      style: {
        fontSize: 10,
        fontColor: isLightMode ? '#1F2937' : '#dfdfdf'
      }
    },
    plotOptions: {
      radar: {
        polygons: {
          strokeColors: isLightMode ? '#e8e8e8' : '#888',
          connectorColors: isLightMode ? '#e8e8e8' : '#888',
          fill: {
            colors: [isLightMode ? '#f8f8f8' : '#5f5f5f', isLightMode ? '#ffffff' : '#3f3f3f']
          }
        }
      }
    },
    theme: {
      mode: isLightMode ? 'light' : 'dark'
    },
    colors: [radarColor],
    markers: {
      size: 4,
      hover: {
        size: 8
      }
    },
    tooltip: {
      intersect: true
    },
    xaxis: {
      categories: categories,
      labels: {
        show: true,
        style: {
          colors: labelColors,
          fontSize: 8
        }
      }
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          fontSize: 10
        }
      }
    }
  }
}
